module.exports = __webpack_public_path__ + "img/extended.08ae4fcb.png";